export default __webpack_public_path__ + "static/media/shadow-clear-summer.cbda1bb3.png";